// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
// tslint:disable-next-line:variable-name
export const IStatusBar = new Token('@jupyterlab/statusbar:IStatusBar');
//# sourceMappingURL=tokens.js.map